<button (click)="clickEvent.emit()" [disabled]="disabled" [ngClass]="buttonType" class="sonect-button" type="button">
  <span class="sonect-button__message">{{ messageAlias | transloco: aliasParams }}</span>
  <span class="sonect-button__value">{{ customValue }}</span>
</button>
